import { Navigate, Route, Routes } from 'react-router-dom'

import { paths } from 'apps'
import { CommonLayout } from 'layouts'
import { PublicRoute } from 'routes'
import { ItemInformation, ProfileMain } from './pages'
import HorseList from './pages/HorseList'
import UserCreateRace from './pages/UserCreateRace'

function Login() {
  return (
    <Routes>
      <Route
        path={paths.default()}
        element={
          <PublicRoute layout={CommonLayout}>
            <ProfileMain />
          </PublicRoute>
        }
      >
        <Route path={paths.profile.itemInformation()} element={<ItemInformation />} />
        <Route path={paths.profile.myProfile()} element={<HorseList />} />
      </Route>
      <Route
        path={paths.profile.createYourRace()}
        element={
          <PublicRoute layout={CommonLayout}>
            <UserCreateRace />
          </PublicRoute>
        }
      />
      <Route path='*' element={<Navigate replace to={paths.notFound.feature()} />} />
    </Routes>
  )
}

export default Login
